<template>
  <div v-show="rememberme == 'false'">
    <div class="bg">
      <div class="container">
        <v-card class="newcard ">
          <v-row>
            <v-col>
              <img
                src="@/assets/imgs/seedadminlogo.png"
                alt="Vue Material Admin"
                width="450px"
                height="650px"
                style="padding-left: 6%;margin-top:9%"
              />
            </v-col>
            <v-col>
              <div style="padding-left:4%">
                <v-row
                  justify="end"
                  style="margin-right:3rem;margin-top:2rem;"
                  v-if="false"
                >
                  <v-menu offset-y :nudge-bottom="10">
                    <template v-slot:activator="{ on: menu }">
                      <v-avatar
                        size="30px"
                        v-on="{ ...menu }"
                        class="mr-4 v-button"
                      >
                        <!-- <flag fab icon :iso="currentflag" v-bind:squared="false" /> -->
                        <img
                          :src="require(`@/assets/imgs/${currentflag}.png`)"
                          style="width:24px;height:24px"
                        />
                      </v-avatar>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="entry in languages"
                        :key="entry.title"
                        @click="
                          changeLocale(
                            entry.language,
                            entry.flag,
                            entry.title,
                            entry.highlighted
                          )
                        "
                      >
                        <v-list-item-action>
                          <!-- <img src="@/assets/imgs/english.png" style="width:24px;height:24px" /> -->
                          <!-- <flag :iso="entry.flag" v-bind:squared="false" /> -->
                          <img
                            :src="require(`@/assets/imgs/${entry.flag}.png`)"
                            style="width:24px;height:24px"
                          />
                        </v-list-item-action>
                        <v-list-item-title>{{ entry.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-row>
                <v-row
                  justify="center"
                  class="img-res"
                  style="margin-top:50px;"
                >
                  <v-col cols="12" sm="8" md="8">
                    <v-img
                      align-center
                      justify-center
                      alt="Seed Logo"
                      class="app img mx-auto mt-10"
                      src="@/assets/imgs/thumbnail_LOGO - Seed 2.png"
                      transition="scale-transition"
                      style="margin-top: -15px;"
                      width="170px"
                      height="162px"
                    />
                    <v-alert
                      type="error"
                      v-model="erroralert"
                      class="text"
                      style="font-size:22px !important"
                      >{{ errorMessage }}</v-alert
                    >
                    <v-alert
                      type="info"
                      v-if="!rememberme"
                      class="text"
                      color="#61803A"
                      v-model="successalert"
                      >{{ successMessage }}</v-alert
                    >
                    <!-- name="login" -->
                    <v-col>
                      <label class="label-style">
                        {{ "Username" }}
                      </label>

                      <v-text-field
                        background-color="#efefef"
                        class="mt-2 text textboxpassword "
                        height="38px"
                        type="text"
                        autocomplete="off"
                        v-model="input.username"
                        outlined
                        :rounded="true"
                      ></v-text-field>
                      <label class="label-style">
                        {{ "Password" }}
                      </label>
                      <v-text-field
                        background-color="#efefef"
                        class="mt-2 text textboxpassword"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show ? 'text' : 'password'"
                        @keyup.enter="login"
                        autocomplete="off"
                        @click:append="show = !show"
                        v-model="input.password"
                        outlined
                        :rounded="true"
                      ></v-text-field>
                    </v-col>
                    <v-row>
                      <v-spacer></v-spacer>
                      <router-link
                        to="/ResetPassword"
                        class=" text labelbold mr-10"
                        >{{ $t("forgotpwd") }}</router-link
                      >
                    </v-row>
                    <v-form class="form ml-5 mr-0 mt-5">
                      <v-row class="remeber">
                        <v-checkbox
                          class="pb-0 pl-3 text"
                          required
                          v-model="rememberMe"
                        ></v-checkbox>
                        <p class="mt-5 ml-1">Remember</p>
                      </v-row>
                    </v-form>

                    <v-layout flex align-center justify-center>
                      <v-btn
                        class="login mt-1"
                        large
                        color="#A6CC39"
                        align="center"
                        justify="center"
                        style="color:#fff!important"
                        @click="login"
                        height="46px"
                        :loading="loading"
                        :rounded="true"
                        >{{ $t("login") }}</v-btn
                      >
                    </v-layout>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#FFF4EB" dark>
        <v-card-text class="black--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#6CC8A0"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="signInModal" persistent max-width="500">
      <v-card style="padding: 10px 5px 10px 0">
        <v-card-text>
          <v-layout row="wrap">
            <v-spacer />
            <v-flex
              shrink
              style="cursor: pointer"
              @click="(signInModal = false), (dialog = false)"
            >
              <v-img
                src="@/assets/close.svg"
                aspect-ratio="1.7"
                width="13"
                height="13"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text style="padding: 0 27px 0">
          <v-layout align-center>
            <v-flex shrink mr-5>
              <v-img
                :src="require(`@/assets/imgs/signin.png`)"
                aspect-ratio="1.7"
                width="60"
                height="60"
              ></v-img>
            </v-flex>
            <v-flex pt-3>
              <p class="alert-text">{{ alert }}</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="#6CC8A0"
            style="color: #fff"
            @click="(signInModal = false), (dialog = false)"
            >{{ $t("ok") }}</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="warningModal" persistent max-width="330">
      <v-card
        style="padding: 10px 5px 10px 0; background-color: #F1DBDB; border: 1px solid #FF0000"
      >
        <v-card-text>
          <v-layout row="wrap">
            <v-spacer />
            <v-flex
              shrink
              style="cursor: pointer"
              @click="(warningModal = false), (dialog = false)"
            >
              <v-img
                src="@/assets/close.svg"
                aspect-ratio="1.7"
                width="13"
                height="13"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text style="padding: 0 27px 0">
          <v-layout align-center>
            <v-flex shrink mr-5>
              <v-img
                :src="require(`@/assets/imgs/signin.png`)"
                aspect-ratio="1.7"
                width="50"
                height="50"
              ></v-img>
            </v-flex>
            <v-flex pt-3>
              <p
                style="color: #000000; font-size: 22px !important"
                class="text"
              >
                Please fill all input.
              </p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="#6CC8A0"
            style="color: #fff"
            @click="(warningModal = false), (dialog = false)"
            >{{ $t("ok") }}</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GlobalMixin from "./Mixins/GlobalMixin";
import enurl from "@/api/environment";
//import axios from "axios";
export default {
  name: "Signin",
  mixins: [GlobalMixin],
  data: () => ({
    currentflag: "us",
    languages: [
      { flag: "th", language: "th", title: "ไทย", highlighted: 0 },
      { flag: "us", language: "en", title: "English", highlighted: 1 },
      { flag: "CN", language: "cn", title: "Chinese", highlighted: 2 },
      { flag: "VN", language: "vn", title: "Vietnam", highlighted: 3 },
      { flag: "MM", language: "mm", title: "Myanmar", highlighted: 4 }
    ],
    checkuserCount: 0,
    checkuser: "",
    alert: "",
    dialog: false,
    signInModal: false,
    warningModal: false,
    loading: false,
    show1: false,
    erroralert: false,
    successalert: false,
    successMessage: "",
    errorMessage: "Please Fill Both UserName and Password!",
    tempUrl: enurl.apiUrl,
    permissionID: "",
    expiryDate: "",
    rememberMe: false,
    rememberme: "false",
    secretKey: "JarvisProductSecretPassphrase@2020",
    input: {
      username: "",
      password: ""
    },
    images: {
      logo: require("@/assets/imgs/SeedLogo.png"),
      BG: require("@/assets/imgs/seedproductadminhome.png")
    },
    show: false
  }),
  props: {},
  mounted: function() {
    let login_username = this.readCookie("productUsername");
    let login_password = this.readCookie("productPassword");
    this.remember = this.readCookie("rememberme");

    if (this.remember == "true") {
      this.rememberMe = true;
      this.expiryDate = this.readCookie("expiredate");
      let today = new Date();
      if (today >= this.expiryDate) {
        document.cookie = "username=" + ";expires=" + this.expiryDate;
        document.cookie = "password=" + ";expires=" + this.expiryDate;
        document.cookie = "rememberme=" + ";expires=" + this.expiryDate;
      } else {
        if (login_username != null && login_password != null) {
          this.input.username = this.cryptoMethods("decrypt", login_username);
          this.input.password = this.cryptoMethods("decrypt", login_password);
        }
      }
    } else {
      this.expiryDate = new Date();
      this.expiryDate.setMonth(this.expiryDate.getMonth() + 1);
      document.cookie = "expiredate=" + this.expiryDate;
    }
  },
  // mounted: function() {
  //   let login_username = this.readCookie("productUsername");
  //   let login_password = this.readCookie("productPassword");
  //   this.rememberme = this.readCookie("rememberme");
  //   if (this.rememberme == "true") {
  //     this.rememberMe=true;
  //     this.expiryDate = this.readCookie("expiredateprod");
  //     let today = new Date();
  //     if (today >= this.expiryDate) {
  //       document.cookie = "productUsername=" + ";expires=" + this.expiryDate;
  //       document.cookie = "productPassword=" + ";expires=" + this.expiryDate;
  //       document.cookie =
  //         "rememberme=" + ";expires=" + this.expiryDate + "; path=/";
  //     } else {
  //       if (login_username != null && login_password != null) {
  //         this.input.username = this.cryptoMethods("decrypt", login_username);
  //         this.input.password = this.cryptoMethods("decrypt", login_password);
  //        this.login();
  //       }
  //     }
  //   } else {
  //     this.rememberme = "false";
  //     this.expiryDate = new Date();
  //     this.expiryDate.setMonth(this.expiryDate.getMonth() + 1);
  //     document.cookie =
  //       "expiredateprod=" + this.expiryDate + ";expires=" + this.expiryDate;
  //   }
  // },
  methods: {
    changeLocale(locale, flag, title, highlighted) {
      this.currentflag = flag;
      this.$i18n.locale = locale;
      this.currentLangTitle = title;
      this.lang = highlighted;
      document.cookie = "langprod=" + locale;
      document.cookie = "flagprod=" + flag;
      document.cookie = "titleprod=" + title;
      document.cookie = "highlighted=" + highlighted;
    },
    login: function() {
      let self = this;
      self.dialog = true;
      self.erroralert = false;
      let userName = this.input.username;
      let password = this.input.password;
      if (userName != "" && password != "") {
        self.$store
          .dispatch("login", { userName, password })
          .then(function(response) {
            // store memberId for createdBy
            localStorage.setItem(
              "vivek_authenticated_admin_data",
              JSON.stringify(response.data.data)
            );
            self.successalert = true;
            self.successMessage = response.data.message;
            self.loading = false;
            self.model = { username: "", password: "" };
            const usertype = response.data.data.userType.trim();
            if (usertype == "COM") {
              self.$store.commit("saveUserImage", response.data.data.image);
              self.$store.commit(
                "saveUserPosition",
                response.data.data.positions
              );
              setTimeout(() => {
                self.$router.push("/dashboard/dashboardMenu");
              }, 1000);
              self.dialog = false;
              document.cookie =
                "productUsername=" +
                self.cryptoMethods("encrypt", userName) +
                ";expires=" +
                self.expiryDate;
              document.cookie =
                "productPassword=" +
                self.cryptoMethods("encrypt", password) +
                ";expires=" +
                self.expiryDate;
              let tempRem =
                self.rememberMe || self.rememberme == "true" ? "true" : "false";
              document.cookie =
                "rememberme=" +
                tempRem +
                ";expires=" +
                self.expiryDate +
                "; path=/";
            } else {
              self.dialog = false;
              alert("Invalid username and password");
              self.rememberme = "false";
            }
          })
          .catch(function(error) {
            console.log(self.checkuserCount);
            if (self.checkuserCount == 3) {
              console.log("becasue of empty block error");
            } else {
              self.alert = error;
              self.signInModal = true;
              if (self.checkuser == self.input.username) {
                self.checkuserCount++;
              } else {
                self.checkuserCount = 0;
              }
              self.checkuser = self.input.username;
            }
          });
      } else {
        self.warningModal = true;
        self.dialog = false;
        self.erroralert = true;
        // self.errorMessage = response.data.message;
        alert("Fill all fields");
      }
    },
    readCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    cryptoMethods(type, value) {
      let self = this;
      if (value != null || value != "" || value != undefined) {
        if (type == "encrypt") {
          const encryptedText = this.CryptoJS.AES.encrypt(
            value,
            self.secretKey
          ).toString();
          return encryptedText;
        } else {
          const decryptedText = this.CryptoJS.AES.decrypt(
            value,
            self.secretKey
          ).toString(this.CryptoJS.enc.Utf8);
          return decryptedText;
        }
      }
    }
  }
};
</script>

<style scoped>
.theme--light .v-label {
  color: #47484b !important;
  font-weight: bold;
}
.labelbold {
  font-size: 10px;
  color: #5a5a5a;
}
.fixed-sn {
  overflow: hidden;
}
.bg {
  background: url("~@/assets/imgs/Component 87 – 98.png") no-repeat center
    center;
  background-size: cover;
  object-fit: contain;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #ffffff;
  transform: scale(1);
}
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Set height to viewport height for vertical centering */
}
.newcard {
  width: 100%;
  height: 800px;
}
.custom-text-field {
  height: 15px; /* Adjust height as needed */
}
* >>> .textboxpassword .v-input__control > .v-input__slot {
  min-height: 38px !important;
}
.label-style {
  font-size: 24px;
  color: #5a5a5a;
}
.remeber {
  margin-bottom: -20px;
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  margin-right: -15px;
  margin-top: -20px;
  margin-left: -15px;
}
* >>> .mdi-eye-off::before {
  margin-bottom: 18px;
}
.box-right {
  margin: auto;
  margin-top: 20%;
}
.img-intersection {
  width: 100%;
  height: 100vh;
  max-width: 100%;
}
.jarvis-logo {
  max-width: 180px;
}
.signin-form {
  margin: 0;
  padding: 2rem 8rem 0;
}
.signin-form input {
  margin-bottom: 20px;
  font-size: 14px;
  color: rgba(67, 66, 93, 1);
  border-top: hidden;
  border-left: hidden;
  border-right: hidden;
  border-radius: 0;
  border-color: rgba(233, 233, 240, 1);
}
.signin-form a,
.signin-form label {
  font-size: 14px;
  text-decoration: none;
  color: rgba(67, 66, 93, 1);
}
.signin-form .btn-login {
  padding-top: 59px;
  width: 100%;
  font-size: 14px;
  background-color: rgba(47, 154, 97, 1);
  color: rgba(255, 255, 255, 1);
}
.login {
  width: 234px;
}
@media screen and (min-device-height: 0px) and (max-device-height: 655px) {
  .img-res {
    margin-top: unset !important;
  }
  .img-intersection {
    height: 100% !important;
  }
}
@media only screen and (max-width: 600px) {
  .bg-unset {
    background-color: unset !important;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
  .bg-unset {
    background-color: unset !important;
  }
}
</style>
